import React from 'react';
import { useTranslation } from 'react-i18next';

import DialogActions from '@mui/material/DialogActions';
import Button, { ButtonProps } from '../Button';
import { createSx } from '../../utils';

const sx = createSx({
  backBtn: {
    position: 'absolute',
    left: theme => theme.spacing(3)
  }
});

interface FooterProps {
  onCancel?: () => void;
  onSubmit?: () => void;
  onBack?: () => void;
  submitDisabled?: boolean;
  submitBtnLabel?: string;
  cancelBtnLabel?: string;
  backBtnLabel?: string;
  submitBntColor?: ButtonProps['color'];
  hideCancelButton?: boolean;
}

const Footer = ({
  onCancel,
  onSubmit,
  onBack,
  submitDisabled,
  submitBtnLabel,
  cancelBtnLabel,
  backBtnLabel,
  submitBntColor = 'primary',
  hideCancelButton,
}: FooterProps) => {
  const { t } = useTranslation();

  return (
    <DialogActions>
      {onBack && <Button
        variant='outlined'
        color='secondary'
        size='large'
        sx={sx.backBtn}
        data-test-id='modal_back_button'
        onClick={onBack}>
        {backBtnLabel || t('backBtn')}
      </Button>}
      {onCancel && !hideCancelButton && <Button
        variant='outlined'
        color='secondary'
        size='large'
        data-test-id='modal_cancel_button'
        onClick={onCancel}>
        {cancelBtnLabel || t('cancelBtn')}
      </Button>}
      {onSubmit && <Button
        color={submitBntColor}
        size='large'
        data-test-id='modal_success_button'
        onClick={onSubmit}
        disabled={submitDisabled}>
        {submitBtnLabel || t('save')}
      </Button>}
    </DialogActions>
  );
};
export default Footer;